import { ColDefWithTab } from "@pages/Assets/common/FilterColumn/context";

export const sortColumnOrder = <T extends { key: string }>(
  columns: T[],
  columnOrder: string[]
): T[] => {
  let res: T[] = [];

  for (const key of columnOrder) {
    const col = columns.find((c) => c.key === key);
    if (col) res.push(col);
  }
  if (columns.length > columnOrder.length) {
    for (const col of columns) {
      if (!columnOrder.includes(col.key.toString())) res.push(col);
    }
  }
  return res;
};

export const applyColumnSizes = <
  K extends string,
  T extends { key: K; width?: number }
>(
  columns: T[],
  sizes: { [key in K]: number }
): T[] =>
  columns.map((col) => {
    const width = sizes[col.key];
    return { ...col, width: width ?? col.width };
  });

type ColumnArrayWithPreferenceFunctions<
  T extends {
    key: string;
    width?: number;
  }
> = Array<T> & {
  sortColumnOrder: (
    columnOrder: string[]
  ) => ColumnArrayWithPreferenceFunctions<T>;
  applyColumnSizes: (sizes: {
    [k in string]: number;
  }) => ColumnArrayWithPreferenceFunctions<T>;
};
export const attachPreferenceFunctions = <
  T extends { key: string; width?: number }
>(
  columns: T[]
): ColumnArrayWithPreferenceFunctions<T> => {
  const casted = columns as unknown as ColumnArrayWithPreferenceFunctions<T>;
  casted.sortColumnOrder = (columnOrder: string[]) =>
    attachPreferenceFunctions(sortColumnOrder(columns, columnOrder));
  casted.applyColumnSizes = (sizes) =>
    attachPreferenceFunctions(applyColumnSizes(casted, sizes));

  return casted;
};
